import './producer-tabs.scss';

import { Box, Container, Tab, Tabs, Typography } from '@mui/material';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';

import BrokerageList from '../brokerage-list/brokerage-list';
import BrokerList from '../brokers-list/broker-list';
import { NewConvergeButton } from '../../../../presentation';
import { Option } from '../../../../presentation/components/table-filter';
import { useConvergeNavigation } from '../../../../contexts';
import { useParams } from 'react-router-dom';

interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function TabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography>{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

type ProducerTabsParams = {
  producerType: string;
};

const ProducerTabs: React.FC = () => {
  const { producerType } = useParams<keyof ProducerTabsParams>();
  const [value, setValue] = useState(producerType === 'brokerages' ? 0 : 1);
  const [brokerageOptions, setbrokerageOptions] = useState<Option[]>([]);
  const navigate = useConvergeNavigation();

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    if (newValue === 1) {
      navigate.producerBrokers();
    } else {
      navigate.producer();
    }
  };

  const updateBrokerageOptions = (options: Option[]) => {
    setbrokerageOptions(options);
  };
  return (
    <>
      <Container maxWidth={false} disableGutters>
        <Box sx={{ width: '100%' }} className="tab-container">
          <Tabs
            value={value}
            onChange={handleChange}
            aria-label="tabs"
            sx={{
              fontWeight: 'bold',
              paddingTop: '45px',
              color: '#000000 !important',
              borderBottom: '1px solid #000000',
              margin: 'auto',
              width: '96.5% !important',
              '& .Mui-selected': {
                fontWeight: 'bold',
              },
            }}
            variant="fullWidth"
          >
            <Tab
              sx={{
                textTransform: 'none',
                fontSize: '16px',
                color: '#000000 !important',
              }} // Override to prevent uppercase
              label="Brokerages"
              {...a11yProps(1)}
            />
            <Tab
              sx={{
                textTransform: 'none',
                fontSize: '16px',
                color: '#000000 !important',
              }} // Override to prevent uppercase
              label="Brokers"
              {...a11yProps(0)}
            />
          </Tabs>

          <TabPanel value={value} index={0}>
            <div>
              <BrokerageList setDefaultBrokerages={updateBrokerageOptions} />
            </div>
          </TabPanel>
          <TabPanel value={value} index={1}>
            <BrokerList defaultBrokerages={brokerageOptions} />
          </TabPanel>
        </Box>
      </Container>
      <Box className="producer-tab-btn-container">
        <Link to="/producers/create-brokerage" className="brokerage-btn">
          <NewConvergeButton label={'ADD NEW BROKERAGE'} variant="contained" />
        </Link>
        <Link to="/producers/create-broker" className="broker-btn">
          <NewConvergeButton label={'ADD NEW BROKER'} variant="contained" />
        </Link>
      </Box>
    </>
  );
};

export default ProducerTabs;
